import React from 'react';

import styles from './pagination.module.scss';

import { DOTS, usePagination } from './usePagination';

const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange && paginationRange.length < 1) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange && paginationRange[paginationRange.length - 1];
  return (
    <ul
      className={`${styles['pagination-container']}`}
    >
      <li
        className={`${styles['pagination-item']} ${currentPage === 1 && styles.disabled}`}
        onClick={onPrevious}
      >
        <div className={`${styles.arrow} ${styles.left}`}/>
      </li>
      {paginationRange && paginationRange.map((pageNumber, pageIdx: number) => {
        if (pageNumber === DOTS) {
          return <li key={'dot-' + pageIdx} className="pagination-item dots">&#8230;</li>;
        }

        return (
          <li
            key={'count-' + pageIdx}
            className={`${styles['pagination-item']} ${pageNumber === currentPage && styles.selected}`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={`${styles['pagination-item']} ${currentPage === lastPage && styles.disabled}`}
        onClick={onNext}
      >
        <div className={`${styles.arrow} ${styles.right}`}/>
      </li>
    </ul>
  );
};

export default Pagination;
